<div class="tab common-tab common-sidepanel-tab" role="tabpanel">
    <div class="graph-header">
        <ul class="nav nav-tabs tab-btn m-0 p-1 w-100" role="tablist" (click)="getSelectedTab($event)">
        <li class="nav-item w-50">
            <a class="nav-link tab-btn-dark active cursor-pointer" (contextmenu)="$event.preventDefault()" href="#notes" aria-controls="loa" role="tab" data-toggle="tab">
            Note
            </a>
        </li>
        <li class="nav-item w-50">
            <a class="nav-link tab-btn-dark cursor-pointer" (contextmenu)="$event.preventDefault()" href="#attachments" aria-controls="loa" role="tab" data-toggle="tab">
                Attachments
            </a>
        </li>
        </ul>
    </div>
    <div class="tab-content pt-0">
        <div role="tabpanel" class="tab-pane active in" id="notes">
            <app-sidepanel-notes [userId]="userId" [carrierId]="carrierId"></app-sidepanel-notes>
        </div>           

        <div role="tabpanel" class="tab-pane" id="attachments">
            <app-sidepanel-attachments [userId]="userId" [carrierId]="carrierId"></app-sidepanel-attachments>
        </div>
    </div>
</div>
